import React, { Fragment } from "react"
import { Menu, Transition } from "@headlessui/react"
import { HiDotsVertical } from "react-icons/hi"
import { useTranslation } from "react-i18next"

const ExtraMenu: React.FC<{
  onRemove: () => void
  onEdit: () => void
}> = ({ onRemove, onEdit }) => {
  const { t } = useTranslation()

  return (
    <Menu as="div" className="tw-relative tw-inline-block tw-text-left">
      <Menu.Button
        aria-label="Open actions"
        className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full hover:tw-bg-dark-25 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-25">
        <HiDotsVertical className="tw-h-5 tw-w-5 tw-text-gray-600" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="tw-transition tw-ease-out tw-duration-100"
        enterFrom="tw-transform tw-opacity-0 tw-scale-95"
        enterTo="tw-transform tw-opacity-100 tw-scale-100"
        leave="tw-transition tw-ease-in tw-duration-75"
        leaveFrom="tw-transform tw-opacity-100 tw-scale-100"
        leaveTo="tw-transform tw-opacity-0 tw-scale-95">
        <Menu.Items className="tw-absolute tw-right-0 tw-z-20 tw-mt-2 tw-w-44 tw-origin-top-right tw-rounded-xl tw-border tw-border-gray-100 tw-bg-white tw-p-1 tw-shadow-lg focus:tw-outline-none">
          <Menu.Item>
            <button
              className="tw-w-full tw-rounded-lg tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-dark hover:tw-bg-gray"
              onClick={onEdit}>
              {t("account.team.button.extra.edit")}
            </button>
          </Menu.Item>
          <Menu.Item>
            <button
              className="tw-w-full tw-rounded-lg tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-red-600 hover:tw-bg-red-50"
              onClick={onRemove}>
              {t("account.team.button.extra.remove")}
            </button>
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default ExtraMenu
